import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Text } from '@ps-design-system/components/Text';
import { Switch } from '@ps-design-system/components/Switch';

import { usePauseModal } from '../context/PauseModalContext';

const PauseToggle = ({ toggle, onToggle, isEndPause }) => {
  const { spaceTitle } = usePauseModal();
  return (
    <div className="pause-toggle">
      <div>
        <Text typeface="body-1-m">
          {isEndPause ? (
            <FormattedMessage
              id="pause.toggle.title_reactivate"
              defaultMessage="Reactivate all listings for {type}"
              values={{
                type: spaceTitle
              }}
            />
          ) : (
            <FormattedMessage
              id="pause.toggle.title"
              defaultMessage="Apply pause to all listings for {type}"
              values={{
                type: spaceTitle
              }}
            />
          )}
        </Text>
      </div>
      <div>
        <Switch
          checked={toggle}
          onCheckedChange={onToggle}
        />
      </div>
    </div>
  );
};

PauseToggle.propTypes = {
  toggle: PropTypes.bool,
  onToggle: PropTypes.func,
  isEndPause: PropTypes.bool,
};

PauseToggle.defaultProps = {
  toggle: false,
  onToggle: () => {},
  isEndPause: false,
};

export default PauseToggle;
